import 'antd/dist/antd.css';

import React from 'react';
import { useApolloClient, useQuery } from 'react-apollo-hooks';
import ErrorDisplay from 'src/components/error';
import Loading from 'src/components/loading';
import Login from 'src/components/login';
import { APP_SETTING, ORDER_INFO_REMOTE } from 'src/components/query/query';

import Main from './Main';

// import "normalize.css";

const App = ({ match, history }) => {
  // 주문번호를 기록한다.
  const { ordno } = match.params;
  const client = useApolloClient();
  client.writeData({
    data: {
      app: {
        __typename: "AppSetting",
        ordno,
      },
    },
  });

  // 주문정보를 불러온다.

  const { data: appSetting } = useQuery(APP_SETTING);
  const { passwordCheck } = appSetting.app;

  const { data, loading } = useQuery(ORDER_INFO_REMOTE, {
    variables: {
      ordno,
    },
  });

  if (loading || !data.orderInfo) {
    return <Loading />;
  }

  if (data.orderInfo && data.orderInfo.success) {
    // 관리자의 경우 패스워드를 통과시켜준다
    if (!passwordCheck && data.orderInfo.isAdmin) {
      client.writeData({
        data: {
          app: {
            __typename: "AppSetting",
            passwordCheck: true,
          },
        },
      });
    }

    if (!passwordCheck) {
      return <Login ordno={ordno} />;
    } else {
      return <Main data={data} />;
    }
  } else {
    return <ErrorDisplay message={data.orderInfo.message} />;
  }
};

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.tsx